"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSiteSettingsFromRoute = exports.getAllDomainsOrDomainNameFromRoute = void 0;

var _reselect = require("reselect");

var _selectors = require("settings-ui-sdk/SiteSettings/selectors");

var _selectors2 = require("settings-ui-sdk/Routes/selectors");

var _SiteSettings = _interopRequireDefault(require("settings-ui-sdk/SiteSettings/SiteSettings"));

var _constants = require("settings-ui-sdk/SiteSettings/constants");

var _getAllDomainsOrDomainNameFromURL = _interopRequireDefault(require("../utils/getAllDomainsOrDomainNameFromURL"));

var getAllDomainsOrDomainNameFromRoute = (0, _reselect.createSelector)([_selectors2.getPathNameFromRouting], function (pathName) {
  return (0, _getAllDomainsOrDomainNameFromURL.default)(pathName);
}); // grab the current domain's site settings, or 'all domains' site settings if none is selected, from the route

exports.getAllDomainsOrDomainNameFromRoute = getAllDomainsOrDomainNameFromRoute;
var getSiteSettingsFromRoute = (0, _reselect.createSelector)([_selectors.getSiteSettings, getAllDomainsOrDomainNameFromRoute], function (siteSettings, selectedDomain) {
  if (selectedDomain === _constants.ALL_DOMAINS_KEY) {
    return siteSettings.get(_constants.ALL_DOMAINS_KEY).set(_constants.ALL_DOMAINS_OR_DOMAIN_NAME, _constants.ALL_DOMAINS_KEY);
  }

  var domainSpecificSettings = siteSettings.getIn(['byDomain', selectedDomain]) || new _SiteSettings.default({});
  return siteSettings.get(_constants.ALL_DOMAINS_KEY).merge(domainSpecificSettings.set(_constants.ALL_DOMAINS_OR_DOMAIN_NAME, selectedDomain));
});
exports.getSiteSettingsFromRoute = getSiteSettingsFromRoute;